/**
 * Kiểm tra xem hóa đơn có phải là hóa đơn từ máy tính tiền hay không.
 * Điều kiện: Ký hiệu hóa đơn (invoiceSerial) có ký tự thứ 5 từ trái sang là 'M' hoặc 'm'.
 * Ví dụ: 1C26MYY, 2C26MYY, 5C26MYY
 */
export const isMachineInvoice = (invoiceSerial?: string | null): boolean => {
  if (!invoiceSerial || invoiceSerial.length < 5) {
    return false;
  }
  return invoiceSerial.charAt(4).toUpperCase() === "M";
};

type InvoiceTypeCompanySource = {
  id?: string | number | null;
  typeCompany?: string | number | null;
  registerInvoiceId?: string | number | null;
  invoiceSerial?: string | null;
  symbolCode?: string | null;
};

/**
 * Lấy typeCompany từ hóa đơn hoặc mẫu đăng ký liên quan khi API danh sách không trả trực tiếp trường này.
 */
export const getRegisteredAssetTypeCompany = (
  invoice?: InvoiceTypeCompanySource | null,
  registerInvoices: InvoiceTypeCompanySource[] = [],
): string | number | null => {
  if (invoice?.typeCompany !== undefined && invoice?.typeCompany !== null) {
    return invoice.typeCompany;
  }

  const matchedRegisterInvoice = registerInvoices.find((registerInvoice) => {
    const matchesId =
      invoice?.registerInvoiceId != null &&
      registerInvoice.id != null &&
      String(invoice.registerInvoiceId) === String(registerInvoice.id);
    const invoiceSerial = invoice?.invoiceSerial ?? invoice?.symbolCode;
    const matchesSerial =
      Boolean(invoiceSerial) &&
      Boolean(registerInvoice.symbolCode) &&
      invoiceSerial === registerInvoice.symbolCode;

    return matchesId || matchesSerial;
  });

  return matchedRegisterInvoice?.typeCompany ?? null;
};

/**
 * Xác định hóa đơn mẫu 01/BTS dựa trên typeCompany của hóa đơn hoặc mẫu đăng ký liên quan.
 * Việc đối chiếu thêm registerInvoiceId và ký hiệu xử lý dữ liệu từ các API trả về shape khác nhau.
 */
export const isRegisteredAssetInvoice = (
  invoice?: InvoiceTypeCompanySource | null,
  registerInvoices: InvoiceTypeCompanySource[] = [],
): boolean => {
  return Number(getRegisteredAssetTypeCompany(invoice, registerInvoices)) === 9;
};
